import {
  createNameSet,
  createRendererSet,
  createSpecSet,
  Link,
  link,
  PersonName,
  personName,
  phone,
  renderLink,
  renderPersonName,
  renderPhone,
  renderText,
  Text,
  text,
} from "@resource/atlas/content-editor/variables";

// set type
// --------

export type GuideBaseVariableSet = {
  atsRecruiterName: PersonName;
  atsCoordinatorName: PersonName;
  candidateName: PersonName;
  candidatePhone: Text;
  jobTitle: Text;
  jobListingLink: Link;
  guideLink: Link;
  companyName: Text;
};

// name set
// --------

export const guideBaseNameSet = createNameSet<GuideBaseVariableSet>({
  atsRecruiterName: {
    name: "ats.recruiter.name",
    label: "Guide recruiter's full name",
  },
  atsCoordinatorName: {
    name: "ats.coordinator.name",
    label: "Coordinator's full name",
  },
  candidateName: {
    name: "candidate.name",
    label: "Candidate's full name",
  },
  candidatePhone: {
    name: "candidate.phone",
    label: "Candidate's phone number",
  },
  jobTitle: {
    name: "job.title",
    label: "Job title",
  },
  jobListingLink: {
    name: "job.listing.link",
    label: "Job listing link",
  },
  guideLink: {
    name: "guide.link",
    label: "Guide link",
  },
  companyName: {
    name: "company.name",
    label: "Company name",
  },
});

// renderer set
// ------------

export const guideBaseRendererSet = createRendererSet<GuideBaseVariableSet>({
  atsRecruiterName: renderPersonName,
  atsCoordinatorName: renderPersonName,
  candidateName: renderPersonName,
  candidatePhone: renderPhone,
  jobTitle: renderText,
  jobListingLink: renderLink,
  guideLink: renderLink,
  companyName: renderText,
});

// spec set
// --------

export const guideBaseSpecSet = createSpecSet<GuideBaseVariableSet>(
  {
    atsRecruiterName: personName(),
    atsCoordinatorName: personName(),
    candidateName: personName(),
    candidatePhone: phone(),
    jobTitle: text(),
    jobListingLink: link(),
    guideLink: link(() => ({ defaultConfig: { label: "interview guide" } })),
    companyName: text(),
  },
  { rendererSet: guideBaseRendererSet, nameSet: guideBaseNameSet }
);
